import { render, staticRenderFns } from "./BibleStudyHeader.vue?vue&type=template&id=318de5a2&scoped=true"
import script from "./BibleStudyHeader.vue?vue&type=script&lang=js"
export * from "./BibleStudyHeader.vue?vue&type=script&lang=js"
import style0 from "./BibleStudyHeader.vue?vue&type=style&index=0&id=318de5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318de5a2",
  null
  
)

export default component.exports